import React, { PureComponent } from 'react';
import PT from 'prop-types';
import DataDensity from './DataDensity';
import TrackPlayerModal from '../TrackPlayerModal';
import StatsKey from './StatsKey';
import InjuryStatus from './InjuryStatus';
import ComparePlayer from './ComparePlayer';
import Matchup from './Matchup';
import classes from './tableControls.css';
import PlayerStatus from './PlayerStatus';
import { Icon, Modal } from 'semantic-ui-react';
import ScheduleDetails from './ScheduleDetails';
import JumpToWeek from './JumpToWeek/JumpToWeek';

export default class TableControls extends PureComponent {
  static propTypes = {
    density: PT.bool,
    injury: PT.bool,
    track: PT.bool,
    compare: PT.bool,
    colGroups: PT.arrayOf(PT.shape({
      name: PT.string,
      columns: PT.arrayOf(PT.string.isRequired).isRequired,
    })),
    matchup: PT.bool,
    statsKeyRight: PT.bool,
    hideStatsKey: PT.bool,
    loggedIn: PT.bool.isRequired,
    scheduleDetails: PT.bool,
    onChangeWeek: PT.func.isRequired,
    lastUpdatedAt: PT.string.isRequired,
    countryList: PT.arrayOf(PT.string),
  }

  static defaultProps = {
    density: true,
    injury: false,
    track: false,
    compare: false,
    colGroups: [],
    matchup: false,
    statsKeyRight: false,
    hideStatsKey: false,
    loggedIn: false,
    scheduleDetails: false,
    onChangeWeek: () => true,
    lastUpdatedAt: '',
    countryList: [],
  }

  getDuplicatesKeys = () => {
    const allcolumns = this.props.colGroups.reduce((arr, group) => arr.concat(group.columns), []);
    return allcolumns.filter((key, idx, arr) => arr.indexOf(key) !== idx)
  }

  generateCitiesScheduleDetails = (cityList) => {
    let legends = []
    cityList.forEach(cityName => {
      legends.push(<ScheduleDetails type={cityName}/>)
    });
    return legends;
  }

  render = () => {
    const { colGroups, density, track, injury, playerStatus, compare, loggedIn, matchup, statsKeyRight, hideStatsKey, scheduleDetails, jumpToWeek, onChangeWeek, lastUpdatedAt, countryList } = this.props;
    // for testing, hide injury data and icon, and also change the style for datadensity
    const { hideInjury, printable } = this.props;
    const abbreviationsKeysObj = this.props.colGroups.reduce((arr, group) => {
      if (group.statKeyColumns !== undefined) {
        return arr.concat(group.statKeyColumns)
      }
      if (group.columns !== undefined) {
        return arr.concat(group.columns)
      }
      return arr.concat(group)
    }, [])
    const duplicatesKeys = this.getDuplicatesKeys()
    return (
      <div className={printable ? classes.printableWrapper : classes.wrapper}>
        <div className={classes.buttons}>
          {track && <TrackPlayerModal loggedIn={loggedIn} />}
          {/* compare && <ComparePlayer loggedIn={loggedIn} /> */}
        </div>

        <div className={classes.icons}>
          {!statsKeyRight &&
            !!colGroups.length &&
            !hideStatsKey &&
            <StatsKey abbreviations={abbreviationsKeysObj} duplicatesKeys={duplicatesKeys} />
          }

          {lastUpdatedAt && lastUpdatedAt !== '' && (
            <div className={classes.lastUpdatedAt}> {lastUpdatedAt} </div>
          )}

          {injury && <InjuryStatus printable={printable} />}

          {matchup && (
            <span className={classes.matchup}>
              <span>Legend:</span>
              <Matchup type="good" />
              <Matchup type="bad" />
              <Matchup type="neutral" />
            </span>
          )}

          {scheduleDetails && (
            <span className={classes.scheduleDetails}>
              <span>Legend:</span>
              <ScheduleDetails type="monday" />
              <ScheduleDetails type="thursday" />
              <ScheduleDetails type="saturday" />
              <ScheduleDetails type="bye" />
              { this.generateCitiesScheduleDetails(countryList) }
            </span>
          )}

          {jumpToWeek && <JumpToWeek className={classes.jumpToWeek} onChangeWeek={onChangeWeek} />}



          {playerStatus && <PlayerStatus printable={printable} /> }

        {/*
          <div className={classes.iconsFirstLine}>
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAcVJREFUOBGlVT1PAkEUvF2OkBDotLEwJMYj9lT+CdGWxsrGxgbDTzChtrK2sFGMFhYWFhZqiKVyBEKHP+DMUXDcObPeAcJyfLjJ8t7Ozs57e7v7EIamBUGQtG27iCn2AvpGSOvC1tFr+Xy+JoToh/jQiKEXOhDah1uF6Nbk3PgYYm2MyxC++YNHAwhIiJ2RFGEL2ipEKwjgk29Gi1YU4/Iy1tKe8kdtmdtEhtcEVm3I8IDblzwAiFRnCPVBvJBSlmAP0W9n8Ajzuyf53YpwtAcAgWNEPYLgWzqdvoNfBHauE6UGtSQmeTV0zctms5etVmt3MBjYrut+YBE/0ZWOHGJKkPdsqiET6ThOx/O8BwgxcAdYgGy3p8gjoCAajYaDcWaEab2nRCKxh5l1ZPsIm9OyDOObkec2ZHaSSqUyvu+/gJyLWRDwHvI5WTEkA1su9Xq9Tdi1OB7mvpgh32Zsw3d7hdh7LOl3sk7B2jwitnxvmubzPB61BCInm83mJ6z2Li4goigI2rYsa0fCYQlatiDo4pSppU6ZbxCMWc9Pt3gSY8VRZWx4bQBUVhRV5SuKoKpNNKBl5YH5f4EdF+VB8aEDW/ov4AfDA69qcvrYIAAAAABJRU5ErkJggg==" />
            <span className={classes.iconText}>&nbsp;Stats Key</span>&nbsp;&nbsp;
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAADhJREFUKBVjZMACXssx/EcXFn3EwIguxoQuQAp/iGpmxBY4xPp7iPqZImdjpBpQYGELxNEUBklGAKfYCCR6/iFwAAAAAElFTkSuQmCC" />
            <span className={classes.iconText}>&nbsp;= Injury Status</span>&nbsp;&nbsp;
          </div>
        */}


        </div>

        <div className={(playerStatus && (hideInjury ? classes.hideDensityChange : classes.densityChange)) || (hideInjury ? classes.hideDensity : classes.density)}>
          {density && <DataDensity />}
          {statsKeyRight &&
            !!colGroups.length &&
            <StatsKey abbreviations={abbreviationsKeysObj} duplicatesKeys={duplicatesKeys} />
          }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/TableControls/TableControls.js